import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useParams } from 'react-router-dom'

import { Notification } from '@components/prereg_validation/notification'
import { useSessionContext } from '@providers/session'
import { i18WithParams as t } from '@shared/locale'
import { useRoutes } from 'app/use_routes'
import { generatePhoneFromString } from 'components-ui/src/shared/common'
import { Spacer } from 'components-ui/src/spacer/spacer'
import { Hooks } from 'service-api'

export const MyProfile = () => {
  const sessionCtx = useSessionContext()
  const { navigateRoute } = useRoutes()
  const { accountName: locationName = '' } = useParams()
  const theme = useTheme()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  const lup = Hooks.useClientLocationUserProfile(locationName, sessionCtx.state.user?.lupId || '')

  const btnEditHandler = () => navigateRoute('myprofileEdit', {})

  const lupCity = lup.data?.city ? `${lup.data.city},` : ''
  const location = [lupCity, lup.data?.state || '', lup.data?.zipCode || ''].filter(Boolean).join(' ')

  return (
    <Box sx={{ width: '100%', pt: 1 }}>
      <Notification lupId={sessionCtx.state.user?.lupId || ''} />

      <Typography variant="h2" pl={isBelowMD ? 2 : 0}>
        {t('profile.myProfile.title')}
      </Typography>
      <Spacer height={2} />

      {lup.isLoading ? (
        <Skeleton variant="rectangular" width="100%" height={200} />
      ) : (
        <Paper elevation={1} sx={{ p: 2 }}>
          <Box>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="h5">
                {lup.data?.firstName} {lup.data?.lastName}
              </Typography>
              <Button variant="text" onClick={btnEditHandler}>
                {t('global.label.edit')}
              </Button>
            </Stack>
            <Spacer height={1} />
            <Stack direction={{ xs: 'column', sm: 'row' }}>
              <Box flex={1}>
                <Typography mb={1}>{generatePhoneFromString(lup.data?.phone ?? undefined)}</Typography>
                <Typography>{lup.data?.email}</Typography>
              </Box>
              <Box flex={1} mt={isBelowMD ? 3 : 0}>
                <Typography variant="h6">{t('contactForm.mailingAddress')}</Typography>
                <Spacer height={1} />
                {lup.data?.streetAddress && <Typography mb={1}>{lup.data.streetAddress}</Typography>}
                {lup.data?.streetAddress2 && <Typography mb={1}>{lup.data.streetAddress2}</Typography>}
                <Typography mb={1}>{location}</Typography>
                <Typography mb={1}>{t('global.select.USA')}</Typography>
              </Box>
            </Stack>
            <Spacer height={1} />
            <Stack direction="column">
              <Typography variant="h6">{t('contactForm.smsConsent')}</Typography>
              <Typography mb={1}>
                {lup.data?.smsConsentStatus === 'ACTIVE'
                  ? t('contactForm.smsConsent.optIn')
                  : t('contactForm.smsConsent.optOut')}
              </Typography>
            </Stack>
          </Box>
        </Paper>
      )}
    </Box>
  )
}
